import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import DoneOutlineIcon from '@material-ui/icons/DoneOutline';

const useStyles = makeStyles((theme) => ({
  root: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(2)
  },
  backgroundCircle: {
    color: theme.palette.grey[400],
  },
  foregroundCircle: {
    animationDuration: '550ms',
    position: 'absolute',
    left: 0,
  }
}));

export default function CircularProgressWithLabel({ percent }) {
  const classes = useStyles();

  return (
    <Box position="relative" display="inline-flex" className={classes.root}>
      <CircularProgress
        variant="determinate"
        className={classes.backgroundCircle}
        value={100}
        thickness={4}
        size={30}
      />
      <CircularProgress
        variant="determinate"
        className={classes.foregroundCircle}
        value={percent}
        thickness={4}
        size={30}
        color={percent === 100 ? "secondary" : "primary"}
      />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        {percent < 100 && percent > 0 &&
          <Typography variant="button" component="div" style={{ fontSize: 11 }}>{`${percent}%`}</Typography>
        }
        {percent === 100 &&
          <DoneOutlineIcon fontSize="small" color="secondary" />
        }
      </Box>
    </Box>
  );
}